var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecomended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80262 0.417433L4.21589 3.52017L0.665805 4.01933C0.0291704 4.10838 -0.225969 4.86532 0.235712 5.29886L2.80412 7.71263L2.19664 11.1224C2.0873 11.7387 2.76038 12.2004 3.32412 11.9121L6.5 10.3021L9.67588 11.9121C10.2396 12.198 10.9127 11.7387 10.8034 11.1224L10.1959 7.71263L12.7643 5.29886C13.226 4.86532 12.9708 4.10838 12.3342 4.01933L8.78411 3.52017L7.19738 0.417433C6.91308 -0.135624 6.08935 -0.142654 5.80262 0.417433Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecomended);
export default __webpack_public_path__ + "static/media/recomended.86ab100ce17c4feea66ecd7d6deac6bd.svg";
export { ForwardRef as ReactComponent };